export default "__VITE_ASSET__DC2rZql5__"